module.exports = __webpack_public_path__ + "img/binance-market-overview-screen.1774e320.webp";